import mergeCredentialOverlay from './mergeCredentialOverlay.js';

const mergeCredentialUpsertSuccess = (credential, { serverCredential, serverCredentialId, overlayContext }) => {
  const optimisticCredential = mergeCredentialOverlay(credential, overlayContext);
  const hasServerCredential = serverCredential && typeof serverCredential === 'object';

  if (!hasServerCredential) {
    return {
      ...optimisticCredential,
      credentialId: serverCredentialId
    };
  }

  return {
    ...optimisticCredential,
    ...serverCredential,
    credentialId: serverCredentialId,
    secrets: serverCredential?.secrets ? { ...(optimisticCredential?.secrets || {}), ...serverCredential.secrets } : optimisticCredential?.secrets,
    meta: serverCredential?.meta ? { ...(optimisticCredential?.meta || {}), ...serverCredential.meta } : optimisticCredential?.meta
  };
};

export default mergeCredentialUpsertSuccess;
